<template>
   <div class="form__item" :class="classes">
      <label v-if="$slots.label" :for="id">
         <slot name="label"></slot>
         <span v-if="required == true" style="color: red;">*</span>
      </label>
      
      <span v-if="$slots.error" class="input__error">
         <i class="fas fa-exclamation-triangle"></i> <slot name="error"></slot>
      </span>
      
      <input @keyup="keyup" v-model="inputValue" v-if="type == 'number'" :id="id" :type="type" step="1" :placeholder="placeholder" :aria-placeholder="placeholder" aria-label="number"  :disabled="disabled" :required="required" ref='input'>
      
      <span v-else-if="type == 'currency'" class="input__currency--container">
         <span class="input__currency--symbol">£</span>
         <input @keyup="keyup" v-model="inputValue" class="input__currency" :id="id" type="number" min="0.00" step="1" :placeholder="placeholder" :aria-placeholder="placeholder" aria-label="currency"  :disabled="disabled" :required="required" ref='input'>
      </span>
      
      <textarea @keyup="keyup" v-model="inputValue" v-else-if="type == 'textarea'" :name="id" :id="id" :placeholder="placeholder" :aria-placeholder="placeholder" aria-label="text"  :disabled="disabled" :required="required" ref='input'></textarea>

      <input @keyup="keyup" v-model="inputValue" v-else :id="id" :type="type" :placeholder="placeholder" :aria-placeholder="placeholder" aria-label="text"  :disabled="disabled" :required="required" ref='input'>
   </div>
</template>

<script>
export default {
    props: {
        id: { type: String, default: null },
        type: { type: String, default: null },
        required: { type: Boolean, default: false },
        placeholder: { type: String, default: '' },
        autofocus: { type: Boolean, default: false },
        disabled: {type: Boolean, default: false},
        value: {
            validator: prop => ['string', 'number'].includes(typeof prop) || prop === null,
            default: null
        },
    },
    computed: {
        inputValue: {
            get () {
                return this.value
            },
            set (value) {
                this.emitValue(value)
            }
        },
        classes() {
           return [this.$tiscPlugin.theme]
        }
    },
    methods: {
        emitValue (value) {
            if(this.number == true || this.currency == true){
                if(value == ''){
                    value = 0;
                }
                value = parseFloat(value);
            }
            this.$emit('input', value)
        }, 
        keyup(e) {
            this.$emit('keyup', e);
        } 
    },
    mounted() {
        this.autofocus ? this.$refs.input.focus() : ''
    }
}
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Forms/input.scss';
</style>